module.exports = "/templates/targets.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/targets.html
// module id = 463
// module chunks = 0